import type {
  FetchNotificationsParams,
  NotificationAudience,
} from "@/types/notification";

/** Query-key factory for the notification domain (`/api/<org>/notifications/`). */
export const notificationKeys = {
  all: ["notifications"] as const,

  lists: () => [...notificationKeys.all, "list"] as const,
  list: (params?: FetchNotificationsParams) =>
    [...notificationKeys.lists(), params ?? {}] as const,

  /** Prefix covering every area's badge — invalidates them all at once. */
  unreadCounts: () => [...notificationKeys.all, "unread-count"] as const,
  /** One badge. Omitting `audience` is the unscoped, org-wide count. */
  unreadCount: (audience?: NotificationAudience) =>
    [...notificationKeys.unreadCounts(), audience ?? "all"] as const,

  settings: () => [...notificationKeys.all, "settings"] as const,
};
